import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import StripeCoonection from "./components/StripeCoonection";
import ReviewSettings from "./components/ReviewSettings";
import { useAgencyInfo } from "context/agency";
import PageTitle from "../../components/PageTitle";
import { useAppServices } from "hook/services";
import { useEffect, useState } from "react";
import Branding from "./components/Branding";
import Business from "./components/Business";
import Consumer from "./components/Consumer";
import CustomTabs from "../../components/CustomTabs";
import ProfileSettings from "./components/ProfileSettings";
import CustomCode from "./components/CustomCode";
import Routes from "../Configurator/components/BasicInfo/BrandingTabs/Routeshandling";
import { Snackbar } from "@mui/material";
import Workflows from "./components/Workflows";
import { useKnowledgeBase } from "context/knowledgebaseContext";
import { useLocation } from "react-router-dom";
import "../settingsCompact.css";

function Settings() {
  const AppService = useAppServices();
  const [agency, , , , , , Update] = useAgencyInfo();
  const [processing, setProcessing] = useState(false);
  const [customFields, setcustomFields] = useState([]);
  const [customValues, setcustomValues] = useState([]);
  const { knowledgeBase, loading } = useKnowledgeBase();
  const [workflows, setworkflows] = useState([]);
  const [selectedTheme, setSelectedTheme] = useState([]);
  const [open, setOpen] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const hasintegerationQuery = searchParams.has("integeration");

  const GetCustomFields = async () => {
    const { response } = await AppService.agency.getworkflows({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      setProcessing(false);
      if (response.data) {
        const temp_custom_fields = response.data.map((item, index) => ({
          ...item,
          label: item?.name,
          value: `${item?.id}-${item.fieldKey}`,
        }));
        setcustomFields(temp_custom_fields);
      }

      if (response?.workflows) {
        const temp_work_flows = response.workflows?.map((item, index) => ({
          ...item,
          label: item?.name,
          value: `${item?.id}`,
        }));
        setworkflows(temp_work_flows);
      }
      if (response?.custom_values) {
        const temp_custom_values = response.custom_values?.map((item, index) => ({
          ...item,
          label: item?.name,
          value: `${item?.id}-${item?.name}`,
        }));
        setcustomValues(temp_custom_values);
      }
    } else {
      setProcessing(false);
    }
  };

  const getActiveTheme = async (queryTheme) => {
    const { response } = await AppService.themes.get({ query: `_id=${agency?.theme_id}` });
    console.log("responseresponse", response?.data);
    if (response) {
      setSelectedTheme(response.data[0]);
    }
  };

  const onLoad = async () => {
    GetCustomFields();
    getActiveTheme();
  };
  useEffect(() => {
    onLoad();
  }, []);

  const handelThemeData = async (data) => {
    console.log("datadatadata", data);
    setButtonLoading(true);
    try {
      const submitData = {
        ...selectedTheme,
      };

      if (submitData.theme_data && submitData.theme_data.domain) {
        console.log(submitData.theme_data.domain, "submitData.theme_data.domain");
        submitData.theme_data.domain.domain_update = false;
      }

      // Shallowly merge every theme_data key passed in (general, routes, elements, etc.);
      // `profile` is excluded because it goes to the payload top-level, not inside theme_data.
      const updatedThemeData = {
        ...submitData.theme_data,
        ...Object.keys(data || {}).reduce((acc, key) => {
          if (key !== "profile") acc[key] = data[key];
          return acc;
        }, {}),
      };

      const payload = {
        agency_id: agency?._id,
        theme_data: updatedThemeData,
        theme_type: "agency",
        theme_id: selectedTheme.theme_id,
        profile: data?.profile,
      };

      const { response, error } = await AppService.themes.updateOrCreateByAgencyId({ payload });
      if (response) {
        setSelectedTheme((prev) => ({
          ...prev,
          theme_data: updatedThemeData,
        }));
        setOpen(true);
        return { success: true, message: "Theme Updated Successfully" };
      }
      return { success: false, message: error?.message || "Failed to update theme" };
    } catch (error) {
      console.error("Error updating theme data: ", error);
      return { success: false, message: error?.message || "Failed to update theme" };
    } finally {
      setButtonLoading(false);
    }
  };

  const handleAutoConfigure = async () => {
    const { response } = await AppService.webhook.auto_configure_data_mapping({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      Update(response.data);
    }
  };
  useEffect(() => {
    if (hasintegerationQuery) {
      setActiveTab(1);
    }
  }, [location.search]);

  const tabsData = [
    {
      label: "Profile Settings",
      content: <ProfileSettings selectedTheme={selectedTheme} handelThemeData={handelThemeData} />,
    },
    { label: "Integrations", content: <StripeCoonection data={agency} /> },
    // {
    //   label: "Business Mapping",
    //   content: <Business data={agency} customFields={customFields} workflows={workflows} />,
    // },
    // {
    //   label: "Consumer Mapping",
    //   content: <Consumer data={agency} customFields={customFields} workflows={workflows} />,
    // },
    // {
    //   label: "Branding Mapping",
    //   content: <Branding data={agency} customValues={customValues} />,
    // },
    {
      label: "Workflow Mapping",
      content: <Workflows data={agency} workflows={workflows} />,
    },
    {
      label: "Review Settings",
      content: <ReviewSettings />,
    },
    {
      label: "Custom Code",
      content: <CustomCode />,
    },
    {
      label: "Custom Names",
      content: (
        <Routes
          selectedTheme={selectedTheme}
          handelThemeData={handelThemeData}
          buttonLoading={buttonLoading}
        />
      ),
    },
  ];
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  return (
    <>
      <style>
        {`
       .kb-help-text-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.kb-help-text-btn:hover {
  background: #eef2ff;
  color: #2f80ed;
  border-color: #c7d2fe;
}

`}
      </style>
      <PageLayout>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          message="Theme Updated Successfully"
          action={[]}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        />
        <SoftBox className="sd-settings sd-page">
            <SoftBox className="sd-settings__header sd-page__header d-flex" style={{ justifyContent: "space-between" }}>
              <PageTitle helpUrl={!loading && knowledgeBase?.settings}>Settings</PageTitle>
              {!agency?.auto_configure && (
                <button
                  onClick={handleAutoConfigure}
                  className="btn-new-design-black-addacount font-16"
                  style={{
                    margin: "0px 0px 0px 10px",
                    padding: "10px 20px",
                    border: "green",
                    color: "green",
                  }}
                  type="submit"
                  variant="outlined"
                  color={"dark"}
                  size="small"
                >
                  Auto Configure
                </button>
              )}
            </SoftBox>
            <CustomTabs tabsData={tabsData} activeTab={activeTab} setActiveTab={setActiveTab} />
        </SoftBox>
      </PageLayout>
    </>
  );
}

export default Settings;
